module.exports = __webpack_public_path__ + "img/background-menu-recuperi.d45f841a.jpg";